import {arrow, computePosition, flip, offset} from '@floating-ui/dom';

export function addShareIconListeners() {
  const hideAll = (block) => {
	  block.classList.add('hidden');
	  block.style.left = '0';
	  block.style.top = '0';
  };
  document.querySelectorAll('.js--share-icon').forEach(function (elem) {
	elem.addEventListener('click', function (e) {
	  e.preventDefault();
	  e.stopPropagation();
	  const shared = e.target.closest('.shared');
	  const floating = shared.querySelector('.shared_block')
	  const arrowNode = floating.querySelector('.js--arrow')
	  if (floating.classList.contains('hidden')) {
		floating.classList.remove('hidden')
		computePosition(shared, floating, {
		  placement: 'bottom-end',
		  middleware: [flip(), offset(4), arrow({element: arrowNode})]
		}).then(({x, y, middlewareData, placement}) => {
		  Object.assign(floating.style, {
			left: `${x}px`,
			top: `${y}px`,
		  })

		  if (middlewareData.arrow) {
			const {x} = middlewareData.arrow;
			const isFlipped = placement.startsWith('top');

			Object.assign(arrowNode.style, {
			  left: `${x}px`,
			  top: isFlipped ? 'auto' : `${-arrowNode.offsetHeight / 2}px`,
			  bottom: isFlipped ? `${-arrowNode.offsetHeight / 2}px` : 'auto',
			});
		  }
		})
	  } else {
		hideAll(floating);
	  }
	})
  })
  document.addEventListener('click', () => {
	document.querySelectorAll('.shared_block:not(.hidden)').forEach(block =>  hideAll(block)
  )})
}
